import React from 'react';
import { shallow, ShallowWrapper } from 'enzyme';
import AtsDisabledButton from './disabled_button';

const createProps = () => ({
  companyId: 1,
});

let props;
let wrapped: ShallowWrapper;

describe('AtsDisabledButton', () => {
  beforeEach(() => {
    props = createProps();
    wrapped = shallow(<AtsDisabledButton {...props} />);
  });

  it('shallow renders without crashing', () => {
    expect(wrapped.exists()).toBe(true);
  });
});

test.todo('add more tests');
